import { useState, useEffect, useRef } from 'react';
import { API, getAuthHeader } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { ClipboardList, Plus, Search, Clock, CheckCircle, AlertTriangle, Edit2, Trash2, User, Phone, MapPin, Calendar, Loader2, X, Play, Navigation, Settings, ExternalLink, UserX, Wrench, Ban, RefreshCw, Eye, Camera, Upload, Car, CheckSquare, XCircle, MessageSquare, FileCheck, Image } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';

const TIPOS_OS = [
  { value: 'instalacao', label: 'Instalação' },
  { value: 'manutencao', label: 'Manutenção' },
  { value: 'suporte', label: 'Suporte Técnico' },
  { value: 'troca_equipamento', label: 'Troca de Equipamento' },
  { value: 'cancelamento', label: 'Cancelamento' },
  { value: 'outros', label: 'Outros' }
];

const PRIORIDADES = [
  { value: 'baixa', label: 'Baixa', color: 'bg-slate-100 text-slate-600' },
  { value: 'normal', label: 'Normal', color: 'bg-blue-100 text-blue-600' },
  { value: 'alta', label: 'Alta', color: 'bg-orange-100 text-orange-600' },
  { value: 'urgente', label: 'Urgente', color: 'bg-red-100 text-red-600' }
];

const STATUS_OS_DEFAULT = [
  { value: 'aberta', label: 'Aberta', color: 'bg-blue-100 text-blue-600' },
  { value: 'do_dia', label: 'Do Dia', color: 'bg-purple-100 text-purple-600' },
  { value: 'em_andamento', label: 'Em Andamento', color: 'bg-yellow-100 text-yellow-600' },
  { value: 'aguardando', label: 'Aguardando', color: 'bg-orange-100 text-orange-600' },
  { value: 'finalizado_tecnico', label: 'Finalizado pelo Técnico', color: 'bg-teal-100 text-teal-600' },
  { value: 'nao_realizado', label: 'Não Realizado', color: 'bg-red-100 text-red-600' },
  { value: 'finalizada', label: 'Finalizada', color: 'bg-green-100 text-green-600' },
  { value: 'cancelada', label: 'Cancelada', color: 'bg-red-100 text-red-600' }
];

// Status de Atendimento Técnico
const STATUS_ATENDIMENTO_TECNICO = [
  { value: 'aguardando_execucao', label: 'Aguardando Execução', color: 'bg-slate-100 text-slate-600', iconName: 'Clock' },
  { value: 'em_deslocamento', label: 'Em Deslocamento', color: 'bg-blue-100 text-blue-600', iconName: 'Car' },
  { value: 'em_atendimento', label: 'Em Atendimento', color: 'bg-yellow-100 text-yellow-600', iconName: 'Wrench' },
  { value: 'finalizado_tecnico', label: 'Finalizado pelo Técnico', color: 'bg-green-100 text-green-600', iconName: 'CheckCircle' },
  { value: 'nao_realizado', label: 'Não Realizado', color: 'bg-red-100 text-red-600', iconName: 'XCircle' }
];

// Mapeamento de ícones
const ICON_MAP = {
  Clock, Car, Wrench, CheckCircle, XCircle
};

// Opções de serviço realizado
const SERVICO_REALIZADO_OPTIONS = [
  { value: 'sim', label: 'Sim', color: 'bg-green-100 text-green-600' },
  { value: 'parcial', label: 'Parcial', color: 'bg-yellow-100 text-yellow-600' },
  { value: 'nao', label: 'Não', color: 'bg-red-100 text-red-600' }
];

// Motivos de não execução
const MOTIVOS_NAO_EXECUCAO = [
  { value: 'cliente_ausente', label: 'Cliente Ausente' },
  { value: 'sem_acesso', label: 'Sem Acesso ao Local' },
  { value: 'endereco_incorreto', label: 'Endereço Incorreto' },
  { value: 'material_insuficiente', label: 'Material Insuficiente' },
  { value: 'problema_externo', label: 'Problema Externo' },
  { value: 'outro', label: 'Outro' }
];

// Categorias de fotos
const CATEGORIAS_FOTOS = [
  { value: 'antes', label: 'Foto Antes do Serviço' },
  { value: 'depois', label: 'Foto Depois do Serviço' },
  { value: 'equipamento', label: 'Equipamento Instalado' },
  { value: 'medicao', label: 'Medição de Sinal' }
];

// Situações que o técnico pode encontrar (legado)
const SITUACOES_DEFAULT = [
  { value: 'cliente_ausente', label: 'Cliente Ausente', icon: 'UserX' },
  { value: 'reagendado', label: 'Reagendado pelo Cliente', icon: 'Calendar' },
  { value: 'problema_acesso', label: 'Problema de Acesso ao Local', icon: 'Ban' },
  { value: 'aguardando_material', label: 'Aguardando Material', icon: 'Wrench' },
  { value: 'servico_concluido', label: 'Serviço Concluído', icon: 'CheckCircle' }
];

export default function OrdensServicoPage() {
  const [ordens, setOrdens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedOS, setSelectedOS] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [tecnicos, setTecnicos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [searchCliente, setSearchCliente] = useState('');
  const [loadingClientes, setLoadingClientes] = useState(false);
  const [saving, setSaving] = useState(false);
  const [syncingIxc, setSyncingIxc] = useState(false);

  // Novos estados para funcionalidades adicionais
  const [STATUS_OS, setStatusOS] = useState(STATUS_OS_DEFAULT);
  const [SITUACOES, setSituacoes] = useState(SITUACOES_DEFAULT);
  const [actionModalOpen, setActionModalOpen] = useState(false);
  const [configModalOpen, setConfigModalOpen] = useState(false);
  const [finalizarModalOpen, setFinalizarModalOpen] = useState(false);
  const [detalhesModalOpen, setDetalhesModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [observacaoAcao, setObservacaoAcao] = useState('');
  const [servicoRealizado, setServicoRealizado] = useState('');
  const [observacaoFinal, setObservacaoFinal] = useState('');
  const [loadingAction, setLoadingAction] = useState(false);
  
  // Estados para Execução Técnica
  const [execucaoModalOpen, setExecucaoModalOpen] = useState(false);
  const [execucaoData, setExecucaoData] = useState({
    status_atendimento: '',
    servico_realizado: '',
    descricao_servico: '',
    motivo_nao_execucao: '',
    motivo_outro: ''
  });
  const [validarModalOpen, setValidarModalOpen] = useState(false);
  const [mensagemModalOpen, setMensagemModalOpen] = useState(false);
  const [uploadingFoto, setUploadingFoto] = useState(false);
  const [fotoCategoria, setFotoCategoria] = useState('antes');
  const fileInputRef = useRef(null);
  
  // Estado para armazenar usuário atual com permissões atualizadas
  const [currentUser, setCurrentUser] = useState(() => JSON.parse(localStorage.getItem('user') || '{}'));
  const isSuperAdmin = currentUser.is_super_admin === true;
  const permissoes = currentUser.permissoes || {};
  
  // Filtro rápido pelos cards de estatísticas
  const [filtroStats, setFiltroStats] = useState(null); // null, 'abertas', 'em_andamento', 'alta_prioridade', 'finalizadas_hoje'
  
  // Recarregar permissões do servidor ao montar o componente
  useEffect(() => {
    axios.get(API + '/auth/me', { headers: getAuthHeader() })
      .then(res => {
        const updatedUser = { ...currentUser, ...res.data };
        setCurrentUser(updatedUser);
        localStorage.setItem('user', JSON.stringify(updatedUser));
      })
      .catch(() => {}); // Silencioso se falhar
  }, []);
  
  // Verificar se é técnico (tem permissão de técnico)
  const ehTecnico = permissoes.ordens_servico_tecnico === true;
  const podeEditar = isSuperAdmin || permissoes.ordens_servico_editar;
  const podeCriar = isSuperAdmin || permissoes.ordens_servico_criar;
  const podeExcluir = isSuperAdmin || permissoes.ordens_servico_excluir;
  const podeExecutar = isSuperAdmin || ehTecnico;
  
  // Técnico puro = tem permissão de técnico MAS não tem permissão de editar/criar
  const ehTecnicoPuro = ehTecnico && !permissoes.ordens_servico_editar && !permissoes.ordens_servico_criar && !isSuperAdmin;
  
  // Status disponíveis - técnicos puros não podem marcar como "do_dia"
  const statusDisponiveisParaUsuario = ehTecnicoPuro 
    ? STATUS_OS.filter(s => s.value !== 'do_dia')
    : STATUS_OS;

  const [formData, setFormData] = useState({
    titulo: '',
    cliente_id: '',
    cliente_nome: '',
    cliente_telefone: '',
    cliente_endereco: '',
    tecnico_id: '',
    tecnico_nome: '',
    tipo: 'instalacao',
    prioridade: 'normal',
    status: 'aberta',
    descricao: '',
    observacoes: '',
    data_agendamento: ''
  });

  useEffect(() => { 
    loadData(); 
    loadTecnicos();
  }, []);

  const loadData = () => {
    setLoading(true);
    axios.get(API + '/ordens-servico', { headers: getAuthHeader() })
      .then(r => setOrdens(r.data.ordens || []))
      .catch(() => toast.error('Erro ao carregar ordens'))
      .finally(() => setLoading(false));
    
    axios.get(API + '/ordens-servico/stats', { headers: getAuthHeader() })
      .then(r => setStats(r.data)).catch(() => {});
  };

  const loadTecnicos = () => {
    axios.get(API + '/users', { headers: getAuthHeader() })
      .then(r => {
        const tecnicosList = r.data.filter(u => u.cargo === 'tecnico' || u.cargo === 'atendente' || u.is_super_admin);
        setTecnicos(tecnicosList);
      })
      .catch(() => {});
  };

  // Carregar configurações de status e situações do backend
  const loadConfiguracoes = () => {
    axios.get(API + '/ordens-servico/configuracoes', { headers: getAuthHeader() })
      .then(r => {
        if (r.data.status_os && r.data.status_os.length > 0) {
          setStatusOS(r.data.status_os);
        }
        if (r.data.situacoes && r.data.situacoes.length > 0) {
          setSituacoes(r.data.situacoes);
        }
      })
      .catch(() => {});
  };

  // Sincronizar OS com IXC
  const sincronizarIxc = async () => {
    setSyncingIxc(true);
    try {
      const response = await axios.post(API + '/ordens-servico/sincronizar-ixc', {}, { headers: getAuthHeader() });
      const data = response.data;
      toast.success(`Sincronização concluída! ${data.importadas} importadas, ${data.atualizadas} atualizadas`);
      loadOrdens();
      loadStats();
    } catch (error) {
      const msg = error.response?.data?.detail || 'Erro ao sincronizar';
      toast.error(msg);
    } finally {
      setSyncingIxc(false);
    }
  };

  useEffect(() => {
    loadConfiguracoes();
  }, []);

  // Abrir modal de ação (iniciar, finalizar, registrar situação)
  const openActionModal = (os, action) => {
    setSelectedOS(os);
    setSelectedAction(action);
    setObservacaoAcao('');
    setActionModalOpen(true);
  };

  // Iniciar OS (mudar para em_andamento)
  const handleIniciarOS = () => {
    if (!selectedOS) return;
    setLoadingAction(true);
    
    axios.put(API + '/ordens-servico/' + selectedOS.id, {
      status: 'em_andamento',
      data_inicio: new Date().toISOString(),
      observacoes: selectedOS.observacoes ? selectedOS.observacoes + '\n\n[INICIADO] ' + observacaoAcao : '[INICIADO] ' + observacaoAcao
    }, { headers: getAuthHeader() })
      .then(() => {
        toast.success('OS iniciada!');
        setActionModalOpen(false);
        loadData();
      })
      .catch(err => toast.error(err.response?.data?.detail || 'Erro ao iniciar OS'))
      .finally(() => setLoadingAction(false));
  };

  // Finalizar OS
  const handleFinalizarOS = () => {
    if (!selectedOS) return;
    setLoadingAction(true);
    
    axios.post(API + '/ordens-servico/' + selectedOS.id + '/finalizar', {
      servico_realizado: servicoRealizado,
      observacoes: observacaoFinal
    }, { headers: getAuthHeader() })
      .then(() => {
        toast.success('OS finalizada com sucesso!');
        setFinalizarModalOpen(false);
        setActionModalOpen(false);
        setServicoRealizado('');
        setObservacaoFinal('');
        loadData();
      })
      .catch(err => toast.error(err.response?.data?.detail || 'Erro ao finalizar OS'))
      .finally(() => setLoadingAction(false));
  };

  // Abrir modal de finalização
  const openFinalizarModal = (os) => {
    setSelectedOS(os);
    setServicoRealizado('');
    setObservacaoFinal('');
    setFinalizarModalOpen(true);
  };

  // Registrar situação (cliente ausente, reagendado, etc.)
  const handleRegistrarSituacao = (situacao) => {
    if (!selectedOS) return;
    setLoadingAction(true);
    
    const situacaoLabel = SITUACOES.find(s => s.value === situacao)?.label || situacao;
    
    axios.put(API + '/ordens-servico/' + selectedOS.id, {
      status: 'aguardando',
      ultima_situacao: situacao,
      observacoes: selectedOS.observacoes ? 
        selectedOS.observacoes + '\n\n[' + situacaoLabel.toUpperCase() + '] ' + observacaoAcao : 
        '[' + situacaoLabel.toUpperCase() + '] ' + observacaoAcao
    }, { headers: getAuthHeader() })
      .then(() => {
        toast.success('Situação registrada!');
        setActionModalOpen(false);
        loadData();
      })
      .catch(err => toast.error(err.response?.data?.detail || 'Erro ao registrar situação'))
      .finally(() => setLoadingAction(false));
  };

  // Abrir mapa com endereço do cliente
  const abrirMapaCliente = (os) => {
    const endereco = os.cliente_endereco || '';
    if (endereco) {
      window.open('https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(endereco), '_blank');
    } else {
      toast.error('Endereço do cliente não disponível');
    }
  };

  // Abrir navegação GPS até o cliente
  const iniciarNavegacao = (os) => {
    const endereco = os.cliente_endereco || '';
    if (endereco) {
      // Tenta abrir no app de mapas nativo (funciona melhor em mobile)
      window.open('https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(endereco), '_blank');
    } else {
      toast.error('Endereço do cliente não disponível');
    }
  };

  const searchClientes = (term) => {
    if (term.length < 2) {
      setClientes([]);
      return;
    }
    setLoadingClientes(true);
    axios.get(API + '/clientes/search?q=' + encodeURIComponent(term), { headers: getAuthHeader() })
      .then(r => setClientes(r.data.slice(0, 10)))
      .catch(() => setClientes([]))
      .finally(() => setLoadingClientes(false));
  };

  const selectCliente = (cliente) => {
    setFormData({
      ...formData,
      cliente_id: cliente.id,
      cliente_nome: cliente.nome,
      cliente_telefone: cliente.telefone || cliente.whatsapp || '',
      cliente_endereco: cliente.endereco ? `${cliente.endereco}, ${cliente.numero || ''} - ${cliente.bairro || ''}, ${cliente.cidade || ''}` : ''
    });
    setSearchCliente('');
    setClientes([]);
  };

  const openCreateModal = () => {
    setSelectedOS(null);
    setFormData({
      titulo: '',
      cliente_id: '',
      cliente_nome: '',
      cliente_telefone: '',
      cliente_endereco: '',
      tecnico_id: '',
      tecnico_nome: '',
      tipo: 'instalacao',
      prioridade: 'normal',
      status: 'aberta',
      descricao: '',
      observacoes: '',
      data_agendamento: ''
    });
    setModalOpen(true);
  };

  const openEditModal = (os) => {
    setSelectedOS(os);
    setFormData({
      titulo: os.titulo || '',
      cliente_id: os.cliente_id || '',
      cliente_nome: os.cliente_nome || '',
      cliente_telefone: os.cliente_telefone || '',
      cliente_endereco: os.cliente_endereco || '',
      tecnico_id: os.tecnico_id || '',
      tecnico_nome: os.tecnico_nome || '',
      tipo: os.tipo || 'instalacao',
      prioridade: os.prioridade || 'normal',
      status: os.status || 'aberta',
      descricao: os.descricao || '',
      observacoes: os.observacoes || '',
      data_agendamento: os.data_agendamento || ''
    });
    setModalOpen(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.cliente_nome) {
      toast.error('Selecione um cliente');
      return;
    }
    if (!formData.titulo) {
      // Gera título automático se não preenchido
      formData.titulo = TIPOS_OS.find(t => t.value === formData.tipo)?.label + ' - ' + formData.cliente_nome;
    }

    setSaving(true);
    const tecnicoSelecionado = tecnicos.find(t => t.id === formData.tecnico_id);
    const payload = {
      ...formData,
      tecnico_nome: tecnicoSelecionado ? tecnicoSelecionado.name : ''
    };

    if (selectedOS) {
      axios.put(API + '/ordens-servico/' + selectedOS.id, payload, { headers: getAuthHeader() })
        .then(() => {
          toast.success('OS atualizada!');
          setModalOpen(false);
          loadData();
        })
        .catch(err => toast.error(err.response?.data?.detail || 'Erro ao atualizar'))
        .finally(() => setSaving(false));
    } else {
      axios.post(API + '/ordens-servico', payload, { headers: getAuthHeader() })
        .then(() => {
          toast.success('OS criada!');
          setModalOpen(false);
          loadData();
        })
        .catch(err => toast.error(err.response?.data?.detail || 'Erro ao criar'))
        .finally(() => setSaving(false));
    }
  };

  const handleDelete = () => {
    if (!selectedOS) return;
    axios.delete(API + '/ordens-servico/' + selectedOS.id, { headers: getAuthHeader() })
      .then(() => {
        toast.success('OS excluída!');
        setDeleteModalOpen(false);
        loadData();
      })
      .catch(err => toast.error(err.response?.data?.detail || 'Erro ao excluir'));
  };

  const getStatusBadge = (status) => {
    const s = STATUS_OS.find(st => st.value === status);
    return s ? s : { label: status, color: 'bg-slate-100 text-slate-600' };
  };

  const getPrioridadeBadge = (prioridade) => {
    const p = PRIORIDADES.find(pr => pr.value === prioridade);
    return p ? p : { label: prioridade, color: 'bg-slate-100 text-slate-600' };
  };

  // ===== FUNÇÕES DE EXECUÇÃO TÉCNICA =====
  
  // Abrir modal de execução técnica
  const openExecucaoModal = (os) => {
    setSelectedOS(os);
    const execucao = os.execucao_tecnica || {};
    setExecucaoData({
      status_atendimento: execucao.status_atendimento || '',
      servico_realizado: execucao.servico_realizado || '',
      descricao_servico: execucao.descricao_servico || '',
      motivo_nao_execucao: execucao.motivo_nao_execucao || '',
      motivo_outro: execucao.motivo_outro || ''
    });
    setExecucaoModalOpen(true);
  };

  // Obter localização GPS atual
  const obterLocalizacao = () => {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve(null);
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          precisao: pos.coords.accuracy
        }),
        () => resolve(null),
        { enableHighAccuracy: true, timeout: 10000 }
      );
    });
  };

  // Atualizar status de atendimento técnico
  const handleAtualizarExecucao = async (novoStatus) => {
    if (!selectedOS) return;
    setLoadingAction(true);
    
    try {
      // Obter localização GPS
      const localizacao = await obterLocalizacao();
      
      const payload = {
        status_atendimento: novoStatus,
        localizacao
      };
      
      // Se for finalização, adicionar dados obrigatórios
      if (novoStatus === 'finalizado_tecnico' || novoStatus === 'nao_realizado') {
        if (execucaoData.servico_realizado === 'nao' && !execucaoData.motivo_nao_execucao) {
          toast.error('Selecione o motivo da não execução');
          setLoadingAction(false);
          return;
        }
        if ((execucaoData.servico_realizado === 'sim' || execucaoData.servico_realizado === 'parcial') && !execucaoData.descricao_servico) {
          toast.error('Descreva o serviço realizado');
          setLoadingAction(false);
          return;
        }
        payload.servico_realizado = execucaoData.servico_realizado;
        payload.descricao_servico = execucaoData.descricao_servico;
        payload.motivo_nao_execucao = execucaoData.motivo_nao_execucao;
        payload.motivo_outro = execucaoData.motivo_outro;
      }
      
      await axios.post(API + '/ordens-servico/' + selectedOS.id + '/execucao-tecnica', payload, { headers: getAuthHeader() });
      
      const statusLabel = STATUS_ATENDIMENTO_TECNICO.find(s => s.value === novoStatus)?.label || novoStatus;
      toast.success(`Status atualizado: ${statusLabel}`);
      setExecucaoModalOpen(false);
      loadData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao atualizar execução');
    } finally {
      setLoadingAction(false);
    }
  };

  // Upload de foto
  const handleUploadFoto = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !selectedOS) return;
    
    setUploadingFoto(true);
    try {
      const formData = new FormData();
      formData.append('foto', file);
      formData.append('categoria', fotoCategoria);
      
      await axios.post(API + '/ordens-servico/' + selectedOS.id + '/fotos', formData, {
        headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' }
      });
      
      toast.success('Foto enviada com sucesso!');
      // Recarregar OS para mostrar a nova foto
      const response = await axios.get(API + '/ordens-servico/' + selectedOS.id, { headers: getAuthHeader() });
      setSelectedOS(response.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao enviar foto');
    } finally {
      setUploadingFoto(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  // Remover foto
  const handleRemoverFoto = async (fotoId) => {
    if (!selectedOS) return;
    try {
      await axios.delete(API + '/ordens-servico/' + selectedOS.id + '/fotos/' + fotoId, { headers: getAuthHeader() });
      toast.success('Foto removida');
      const response = await axios.get(API + '/ordens-servico/' + selectedOS.id, { headers: getAuthHeader() });
      setSelectedOS(response.data);
    } catch (err) {
      toast.error('Erro ao remover foto');
    }
  };

  // Validar OS (atendente)
  const handleValidarOS = async (acao, observacoes = '') => {
    if (!selectedOS) return;
    setLoadingAction(true);
    try {
      await axios.post(API + '/ordens-servico/' + selectedOS.id + '/validar', { acao, observacoes }, { headers: getAuthHeader() });
      toast.success(acao === 'aprovar' ? 'OS finalizada com sucesso!' : 'OS devolvida ao técnico');
      setValidarModalOpen(false);
      loadData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao validar OS');
    } finally {
      setLoadingAction(false);
    }
  };

  // Enviar mensagem para o cliente
  const handleEnviarMensagemCliente = async (tipo) => {
    if (!selectedOS) return;
    setLoadingAction(true);
    try {
      await axios.post(API + '/ordens-servico/' + selectedOS.id + '/enviar-mensagem-cliente', { tipo }, { headers: getAuthHeader() });
      toast.success('Mensagem enviada ao cliente!');
      setMensagemModalOpen(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao enviar mensagem');
    } finally {
      setLoadingAction(false);
    }
  };

  // Obter status do atendimento técnico
  const getStatusAtendimentoBadge = (status) => {
    const s = STATUS_ATENDIMENTO_TECNICO.find(st => st.value === status);
    return s || { label: status || 'Aguardando', color: 'bg-slate-100 text-slate-600', iconName: 'Clock' };
  };

  const filteredOrdens = ordens.filter(os => {
    // Filtro pelos cards de estatísticas (prioridade)
    if (filtroStats) {
      if (filtroStats === 'abertas') {
        // OS abertas = status aberta ou do_dia
        if (os.status !== 'aberta' && os.status !== 'do_dia') return false;
      }
      if (filtroStats === 'em_andamento') {
        if (os.status !== 'em_andamento') return false;
      }
      if (filtroStats === 'alta_prioridade') {
        // Alta prioridade = prioridade alta ou urgente
        if (os.prioridade !== 'alta' && os.prioridade !== 'urgente') return false;
      }
      if (filtroStats === 'finalizadas_hoje') {
        // Finalizadas hoje
        if (os.status !== 'finalizada') return false;
        if (!os.updated_at && !os.finalizada_em) return false;
        var dataHoje = new Date();
        var dataFinalizacao = new Date(os.finalizada_em || os.updated_at);
        if (dataHoje.toDateString() !== dataFinalizacao.toDateString()) return false;
      }
    }
    
    const matchSearch = !searchTerm || 
      os.cliente_nome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      os.numero?.toString().includes(searchTerm) ||
      os.tecnico_nome?.toLowerCase().includes(searchTerm.toLowerCase());
    
    // Filtro por status do dropdown (só aplica se não tiver filtro de stats)
    const matchStatus = filtroStats || !filterStatus || os.status === filterStatus;
    
    // Regra: Ocultar OS finalizadas/canceladas da lista principal
    // Elas só aparecem quando o usuário pesquisa ou filtra por esse status específico
    const isFinalizadaOuCancelada = os.status === 'finalizada' || os.status === 'cancelada';
    const usuarioPesquisando = searchTerm && searchTerm.length > 0;
    const usuarioFiltrouPorStatus = filterStatus === 'finalizada' || filterStatus === 'cancelada';
    const usuarioFiltrouPorCard = filtroStats === 'finalizadas_hoje';
    
    // Se é finalizada/cancelada, só mostra se estiver pesquisando ou filtrou por esse status ou pelo card
    if (isFinalizadaOuCancelada && !usuarioPesquisando && !usuarioFiltrouPorStatus && !usuarioFiltrouPorCard) {
      return false;
    }
    
    return matchSearch && matchStatus;
  });

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
          <ClipboardList className="w-7 h-7 text-blue-500" />
          {ehTecnico ? 'Minhas Ordens de Serviço' : 'Ordens de Serviço'}
        </h1>
        <div className="flex gap-2">
          {isSuperAdmin && (
            <>
              <Button onClick={sincronizarIxc} variant="outline" disabled={syncingIxc} data-testid="sync-ixc-btn">
                <RefreshCw className={`w-4 h-4 mr-2 ${syncingIxc ? 'animate-spin' : ''}`} />
                {syncingIxc ? 'Sincronizando...' : 'Sincronizar IXC'}
              </Button>
              <Button onClick={() => setConfigModalOpen(true)} variant="outline" data-testid="config-os-btn">
                <Settings className="w-4 h-4 mr-2" />Configurar
              </Button>
            </>
          )}
          {podeCriar && (
            <Button onClick={openCreateModal} className="bg-blue-600 hover:bg-blue-700" data-testid="nova-os-btn">
              <Plus className="w-4 h-4 mr-2" />Nova OS
            </Button>
          )}
        </div>
      </div>

      {/* Cards de Estatísticas - Clicáveis para filtrar */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div 
          className={'bg-white rounded-xl p-4 border shadow-sm cursor-pointer transition-all hover:shadow-md ' + 
            (filtroStats === 'abertas' ? 'border-blue-500 ring-2 ring-blue-200' : 'border-slate-200')}
          onClick={function() { setFiltroStats(filtroStats === 'abertas' ? null : 'abertas'); }}
          title="Clique para filtrar OS abertas"
        >
          <p className="text-slate-500 text-sm">{ehTecnico ? 'Minhas OS' : 'OS Abertas'}</p>
          <p className="text-2xl font-bold text-slate-800">{ehTecnico ? stats.minhas_os || filteredOrdens.length : stats.total_abertas || 0}</p>
        </div>
        <div 
          className={'bg-white rounded-xl p-4 border shadow-sm cursor-pointer transition-all hover:shadow-md ' + 
            (filtroStats === 'em_andamento' ? 'border-orange-500 ring-2 ring-orange-200' : 'border-slate-200')}
          onClick={function() { setFiltroStats(filtroStats === 'em_andamento' ? null : 'em_andamento'); }}
          title="Clique para filtrar OS em andamento"
        >
          <p className="text-slate-500 text-sm">Em Andamento</p>
          <p className="text-2xl font-bold text-orange-600">{stats.total_em_andamento || 0}</p>
        </div>
        <div 
          className={'bg-white rounded-xl p-4 border shadow-sm cursor-pointer transition-all hover:shadow-md ' + 
            (filtroStats === 'alta_prioridade' ? 'border-red-500 ring-2 ring-red-200' : 'border-slate-200')}
          onClick={function() { setFiltroStats(filtroStats === 'alta_prioridade' ? null : 'alta_prioridade'); }}
          title="Clique para filtrar OS com alta prioridade"
        >
          <p className="text-slate-500 text-sm">Alta Prioridade</p>
          <p className="text-2xl font-bold text-red-600">{stats.alta_prioridade || 0}</p>
        </div>
        <div 
          className={'bg-white rounded-xl p-4 border shadow-sm cursor-pointer transition-all hover:shadow-md ' + 
            (filtroStats === 'finalizadas_hoje' ? 'border-green-500 ring-2 ring-green-200' : 'border-slate-200')}
          onClick={function() { setFiltroStats(filtroStats === 'finalizadas_hoje' ? null : 'finalizadas_hoje'); }}
          title="Clique para filtrar OS finalizadas hoje"
        >
          <p className="text-slate-500 text-sm">Finalizadas Hoje</p>
          <p className="text-2xl font-bold text-green-600">{stats.total_finalizadas_hoje || 0}</p>
        </div>
      </div>
      
      {/* Indicador de filtro ativo */}
      {filtroStats && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg px-4 py-2 flex items-center justify-between">
          <span className="text-sm text-yellow-800">
            <strong>Filtro ativo:</strong> {filtroStats === 'abertas' ? 'OS Abertas' : 
                       filtroStats === 'em_andamento' ? 'Em Andamento' : 
                       filtroStats === 'alta_prioridade' ? 'Alta Prioridade' : 'Finalizadas Hoje'}
          </span>
          <button 
            onClick={function() { setFiltroStats(null); }}
            className="text-yellow-700 hover:text-yellow-900 text-sm font-medium flex items-center gap-1"
          >
            <X className="w-4 h-4" /> Limpar filtro
          </button>
        </div>
      )}

      {/* Filtros */}
      <div className="bg-white rounded-xl p-4 border border-slate-200 flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <Input 
              placeholder="Buscar por cliente, número ou técnico..." 
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              className="pl-10"
              data-testid="search-os-input"
            />
          </div>
        </div>
        <select 
          value={filterStatus} 
          onChange={e => setFilterStatus(e.target.value)}
          className="h-10 rounded-md border border-slate-300 bg-white px-3 text-sm"
          data-testid="filter-status-select"
        >
          <option value="">Todos os Status</option>
          {STATUS_OS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </div>
      
      {/* Dica: OS finalizadas ocultas */}
      {!searchTerm && filterStatus !== 'finalizada' && filterStatus !== 'cancelada' && (
        <p className="text-xs text-slate-400 -mt-4 ml-1">
          OS finalizadas e canceladas estão ocultas. Use a pesquisa ou filtre por status para encontrá-las.
        </p>
      )}

      {loading ? (
        <div className="bg-white rounded-xl p-8 text-center border">
          <div className="animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
        </div>
      ) : (
        <div className="bg-white rounded-xl border overflow-hidden">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow className="bg-slate-50">
                  <TableHead className="font-semibold">Nº</TableHead>
                  <TableHead className="font-semibold">Cliente</TableHead>
                  <TableHead className="font-semibold hidden md:table-cell">Tipo</TableHead>
                  <TableHead className="font-semibold">Status</TableHead>
                  <TableHead className="font-semibold hidden sm:table-cell">Prioridade</TableHead>
                  <TableHead className="font-semibold hidden lg:table-cell">Técnico</TableHead>
                  <TableHead className="font-semibold hidden xl:table-cell">Criado por</TableHead>
                  <TableHead className="font-semibold hidden lg:table-cell">Agendamento</TableHead>
                  <TableHead className="text-right font-semibold">Ações</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredOrdens.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} className="text-center py-8 text-slate-500">
                      Nenhuma ordem de serviço encontrada
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredOrdens.map(os => (
                    <TableRow key={os.id} className="hover:bg-slate-50">
                      <TableCell className="font-medium text-blue-600">#{os.numero || '-'}</TableCell>
                      <TableCell>
                        <div>
                          <p className="font-medium text-slate-800">{os.cliente_nome || '-'}</p>
                          <p className="text-xs text-slate-500 md:hidden">{TIPOS_OS.find(t => t.value === os.tipo)?.label || os.tipo}</p>
                        </div>
                      </TableCell>
                      <TableCell className="hidden md:table-cell">
                        <span className="text-sm text-slate-600">{TIPOS_OS.find(t => t.value === os.tipo)?.label || os.tipo}</span>
                      </TableCell>
                      <TableCell>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusBadge(os.status).color}`}>
                          {getStatusBadge(os.status).label}
                        </span>
                      </TableCell>
                      <TableCell className="hidden sm:table-cell">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPrioridadeBadge(os.prioridade).color}`}>
                          {getPrioridadeBadge(os.prioridade).label}
                        </span>
                      </TableCell>
                      <TableCell className="hidden lg:table-cell">
                        <span className="text-sm text-slate-600">{os.tecnico_nome || '-'}</span>
                      </TableCell>
                      <TableCell className="hidden xl:table-cell">
                        <span className="text-sm text-slate-600">{os.created_by_nome || '-'}</span>
                      </TableCell>
                      <TableCell className="hidden lg:table-cell">
                        <span className="text-sm text-slate-600">
                          {os.data_agendamento ? new Date(os.data_agendamento).toLocaleDateString('pt-BR') : '-'}
                        </span>
                      </TableCell>
                      <TableCell className="text-right">
                        <div className="flex justify-end gap-1">
                          {/* Botão Navegação GPS */}
                          {os.cliente_endereco && (
                            <Button 
                              onClick={() => iniciarNavegacao(os)} 
                              variant="ghost" 
                              size="sm" 
                              className="h-8 w-8 p-0 text-blue-500 hover:text-blue-600"
                              title="Navegar até o cliente"
                              data-testid={`nav-btn-${os.id}`}
                            >
                              <Navigation className="w-4 h-4" />
                            </Button>
                          )}
                          
                          {/* Botão Execução Técnica (para quem tem permissão de técnico) */}
                          {(os.status !== 'finalizada' && os.status !== 'cancelada') && podeExecutar && (
                            <Button 
                              onClick={() => openExecucaoModal(os)} 
                              variant="ghost" 
                              size="sm" 
                              className="h-8 w-8 p-0 text-purple-500 hover:text-purple-600"
                              title="Execução Técnica"
                              data-testid={`execucao-btn-${os.id}`}
                            >
                              <Wrench className="w-4 h-4" />
                            </Button>
                          )}

                          {/* Botão Enviar Mensagem ao Cliente */}
                          {os.cliente_telefone && (os.status === 'em_andamento' || os.status === 'aberta') && (
                            <Button 
                              onClick={() => { setSelectedOS(os); setMensagemModalOpen(true); }} 
                              variant="ghost" 
                              size="sm" 
                              className="h-8 w-8 p-0 text-green-500 hover:text-green-600"
                              title="Enviar Mensagem ao Cliente"
                              data-testid={`msg-btn-${os.id}`}
                            >
                              <MessageSquare className="w-4 h-4" />
                            </Button>
                          )}
                          
                          {/* Botão Validar OS (para atendentes - quando técnico finalizou) */}
                          {podeEditar && (os.status === 'finalizado_tecnico' || os.status === 'nao_realizado') && (
                            <Button 
                              onClick={() => { setSelectedOS(os); setValidarModalOpen(true); }} 
                              variant="ghost" 
                              size="sm" 
                              className="h-8 w-8 p-0 text-teal-500 hover:text-teal-600"
                              title="Validar Finalização"
                              data-testid={`validar-btn-${os.id}`}
                            >
                              <FileCheck className="w-4 h-4" />
                            </Button>
                          )}
                          
                          {/* Botão Ver Detalhes */}
                          <Button 
                            onClick={() => { setSelectedOS(os); setDetalhesModalOpen(true); }} 
                            variant="ghost" 
                            size="sm" 
                            className="text-blue-600 hover:text-blue-700 h-8 w-8 p-0"
                            title="Ver Detalhes"
                            data-testid={`detalhes-btn-${os.id}`}
                          >
                            <Eye className="w-4 h-4" />
                          </Button>
                          
                          {/* Botão Editar (apenas se tiver permissão) */}
                          {podeEditar && (
                            <Button onClick={() => openEditModal(os)} variant="ghost" size="sm" className="h-8 w-8 p-0" title="Editar" data-testid={`edit-btn-${os.id}`}>
                              <Edit2 className="w-4 h-4" />
                            </Button>
                          )}
                          
                          {/* Botão Finalizar (para atendentes) */}
                          {podeEditar && os.status !== 'finalizada' && os.status !== 'cancelada' && os.status !== 'finalizado_tecnico' && os.status !== 'nao_realizado' && (
                            <Button 
                              onClick={() => openFinalizarModal(os)} 
                              variant="ghost" 
                              size="sm" 
                              className="text-green-600 hover:text-green-700 h-8 w-8 p-0"
                              title="Finalizar OS"
                              data-testid={`finalizar-btn-${os.id}`}
                            >
                              <CheckCircle className="w-4 h-4" />
                            </Button>
                          )}
                          
                          {/* Botão Excluir (apenas se tiver permissão) */}
                          {podeExcluir && (
                            <Button 
                              onClick={() => { setSelectedOS(os); setDeleteModalOpen(true); }} 
                              variant="ghost" 
                              size="sm" 
                              className="text-red-500 hover:text-red-600 h-8 w-8 p-0"
                              title="Excluir"
                              data-testid={`delete-btn-${os.id}`}
                            >
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      )}

      {/* Modal Criar/Editar OS */}
      <Dialog open={modalOpen} onOpenChange={setModalOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{selectedOS ? 'Editar OS #' + selectedOS.numero : 'Nova Ordem de Serviço'}</DialogTitle>
          </DialogHeader>
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Cliente */}
            <div className="border-b pb-4">
              <h3 className="text-sm font-semibold text-slate-600 mb-3 flex items-center gap-2">
                <User className="w-4 h-4" /> Cliente
              </h3>
              <div className="space-y-3">
                {!formData.cliente_nome ? (
                  <div className="relative">
                    <Input 
                      placeholder="Buscar cliente por nome, telefone ou CPF..."
                      value={searchCliente}
                      onChange={e => { setSearchCliente(e.target.value); searchClientes(e.target.value); }}
                    />
                    {loadingClientes && <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 animate-spin text-slate-400" />}
                    {clientes.length > 0 && (
                      <div className="absolute z-10 w-full bg-white border rounded-md shadow-lg mt-1 max-h-48 overflow-y-auto">
                        {clientes.map(c => (
                          <div 
                            key={c.id} 
                            onClick={() => selectCliente(c)}
                            className="p-3 hover:bg-slate-50 cursor-pointer border-b last:border-b-0"
                          >
                            <p className="font-medium text-slate-800">{c.nome}</p>
                            <p className="text-xs text-slate-500">{c.telefone || c.whatsapp} - {c.cidade}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="bg-slate-50 p-3 rounded-lg">
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="font-medium text-slate-800">{formData.cliente_nome}</p>
                        {formData.cliente_telefone && (
                          <p className="text-sm text-slate-600 flex items-center gap-1">
                            <Phone className="w-3 h-3" /> {formData.cliente_telefone}
                          </p>
                        )}
                        {formData.cliente_endereco && (
                          <p className="text-sm text-slate-500 flex items-center gap-1">
                            <MapPin className="w-3 h-3" /> {formData.cliente_endereco}
                          </p>
                        )}
                      </div>
                      <Button 
                        type="button" 
                        variant="ghost" 
                        size="sm"
                        onClick={() => setFormData({ ...formData, cliente_id: '', cliente_nome: '', cliente_telefone: '', cliente_endereco: '' })}
                      >
                        <X className="w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Título da OS */}
            <div className="space-y-2">
              <Label>Título da OS</Label>
              <Input 
                value={formData.titulo}
                onChange={e => setFormData({ ...formData, titulo: e.target.value })}
                placeholder="Ex: Instalação de fibra - João Silva (deixe em branco para gerar automático)"
              />
            </div>

            {/* Detalhes da OS */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="space-y-2">
                <Label>Tipo de Serviço</Label>
                <select 
                  value={formData.tipo} 
                  onChange={e => setFormData({ ...formData, tipo: e.target.value })}
                  className="w-full h-10 rounded-md border border-slate-300 bg-white px-3 text-sm"
                  required
                >
                  {TIPOS_OS.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
              <div className="space-y-2">
                <Label>Prioridade</Label>
                <select 
                  value={formData.prioridade} 
                  onChange={e => setFormData({ ...formData, prioridade: e.target.value })}
                  className="w-full h-10 rounded-md border border-slate-300 bg-white px-3 text-sm"
                >
                  {PRIORIDADES.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                </select>
              </div>
              <div className="space-y-2">
                <Label>Status</Label>
                <select 
                  value={formData.status} 
                  onChange={e => setFormData({ ...formData, status: e.target.value })}
                  className="w-full h-10 rounded-md border border-slate-300 bg-white px-3 text-sm"
                >
                  {statusDisponiveisParaUsuario.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                </select>
              </div>
            </div>

            {/* Técnico e Agendamento */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Técnico Responsável</Label>
                <select 
                  value={formData.tecnico_id} 
                  onChange={e => setFormData({ ...formData, tecnico_id: e.target.value })}
                  className="w-full h-10 rounded-md border border-slate-300 bg-white px-3 text-sm"
                >
                  <option value="">Selecione um técnico...</option>
                  {tecnicos.map(t => (
                    <option key={t.id} value={t.id}>
                      {t.name} {t.cargo ? `(${t.cargo})` : ''}
                    </option>
                  ))}
                </select>
              </div>
              <div className="space-y-2">
                <Label>Data de Agendamento</Label>
                <Input 
                  type="datetime-local"
                  value={formData.data_agendamento}
                  onChange={e => setFormData({ ...formData, data_agendamento: e.target.value })}
                />
              </div>
            </div>

            {/* Descrição */}
            <div className="space-y-2">
              <Label>Descrição do Serviço</Label>
              <textarea 
                value={formData.descricao}
                onChange={e => setFormData({ ...formData, descricao: e.target.value })}
                className="w-full h-24 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm resize-none"
                placeholder="Descreva o serviço a ser realizado..."
              />
            </div>

            {/* Observações */}
            <div className="space-y-2">
              <Label>Observações</Label>
              <textarea 
                value={formData.observacoes}
                onChange={e => setFormData({ ...formData, observacoes: e.target.value })}
                className="w-full h-20 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm resize-none"
                placeholder="Observações adicionais..."
              />
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t">
              <Button type="button" variant="outline" onClick={() => setModalOpen(false)}>Cancelar</Button>
              <Button type="submit" disabled={saving} className="bg-blue-600 hover:bg-blue-700">
                {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
                {selectedOS ? 'Atualizar' : 'Criar OS'}
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      {/* Modal Confirmar Exclusão */}
      <Dialog open={deleteModalOpen} onOpenChange={setDeleteModalOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Confirmar Exclusão</DialogTitle>
          </DialogHeader>
          <p className="text-slate-600">
            Tem certeza que deseja excluir a OS #{selectedOS?.numero}?
          </p>
          <div className="flex justify-end gap-3 pt-4">
            <Button variant="outline" onClick={() => setDeleteModalOpen(false)}>Cancelar</Button>
            <Button onClick={handleDelete} className="bg-red-600 hover:bg-red-700">Excluir</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal de Ação (Iniciar/Finalizar/Situação) */}
      <Dialog open={actionModalOpen} onOpenChange={setActionModalOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>
              {selectedAction === 'iniciar' && 'Iniciar Ordem de Serviço'}
              {selectedAction === 'situacao' && 'Registrar Situação / Finalizar'}
            </DialogTitle>
          </DialogHeader>
          
          {selectedOS && (
            <div className="space-y-4">
              {/* Info do Cliente */}
              <div className="bg-slate-50 p-3 rounded-lg">
                <p className="font-medium text-slate-800">OS #{selectedOS.numero} - {selectedOS.cliente_nome}</p>
                {selectedOS.cliente_endereco && (
                  <div className="flex items-center gap-2 mt-2">
                    <p className="text-sm text-slate-600 flex-1">{selectedOS.cliente_endereco}</p>
                    <Button 
                      onClick={() => iniciarNavegacao(selectedOS)} 
                      size="sm" 
                      variant="outline"
                      className="text-blue-600"
                    >
                      <Navigation className="w-4 h-4 mr-1" />
                      Navegar
                    </Button>
                  </div>
                )}
              </div>

              {/* Ação: Iniciar */}
              {selectedAction === 'iniciar' && (
                <>
                  <div className="space-y-2">
                    <Label>Observação (opcional)</Label>
                    <textarea 
                      value={observacaoAcao}
                      onChange={e => setObservacaoAcao(e.target.value)}
                      className="w-full h-20 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm resize-none"
                      placeholder="Adicione uma observação ao iniciar..."
                    />
                  </div>
                  <div className="flex justify-end gap-3 pt-4">
                    <Button variant="outline" onClick={() => setActionModalOpen(false)}>Cancelar</Button>
                    <Button 
                      onClick={handleIniciarOS} 
                      disabled={loadingAction}
                      className="bg-green-600 hover:bg-green-700"
                    >
                      {loadingAction && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
                      <Play className="w-4 h-4 mr-2" />
                      Iniciar OS
                    </Button>
                  </div>
                </>
              )}

              {/* Ação: Situação/Finalizar */}
              {selectedAction === 'situacao' && (
                <>
                  <div className="space-y-3">
                    <Label>Selecione uma situação:</Label>
                    <div className="grid grid-cols-1 gap-2">
                      {SITUACOES.map(sit => (
                        <button
                          key={sit.value}
                          onClick={() => {
                            if (sit.value === 'servico_concluido') {
                              setActionModalOpen(false);
                              openFinalizarModal(selectedOS);
                            } else {
                              handleRegistrarSituacao(sit.value);
                            }
                          }}
                          disabled={loadingAction}
                          className={`flex items-center gap-3 p-3 rounded-lg border text-left transition-colors ${
                            sit.value === 'servico_concluido' 
                              ? 'border-green-300 bg-green-50 hover:bg-green-100 text-green-800' 
                              : 'border-slate-200 bg-white hover:bg-slate-50 text-slate-700'
                          }`}
                        >
                          {sit.icon === 'UserX' && <UserX className="w-5 h-5" />}
                          {sit.icon === 'Calendar' && <Calendar className="w-5 h-5" />}
                          {sit.icon === 'Ban' && <Ban className="w-5 h-5" />}
                          {sit.icon === 'Wrench' && <Wrench className="w-5 h-5" />}
                          {sit.icon === 'CheckCircle' && <CheckCircle className="w-5 h-5 text-green-600" />}
                          <span className="font-medium">{sit.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="space-y-2">
                    <Label>Observação (opcional)</Label>
                    <textarea 
                      value={observacaoAcao}
                      onChange={e => setObservacaoAcao(e.target.value)}
                      className="w-full h-20 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm resize-none"
                      placeholder="Adicione detalhes sobre a situação..."
                    />
                  </div>
                  <div className="flex justify-end pt-4">
                    <Button variant="outline" onClick={() => setActionModalOpen(false)}>Cancelar</Button>
                  </div>
                </>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de Configuração (Super Admin) */}
      <Dialog open={configModalOpen} onOpenChange={setConfigModalOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Settings className="w-5 h-5" />
              Configurar Ordens de Serviço
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-6">
            {/* Configurar Situações */}
            <div>
              <h3 className="font-semibold text-slate-800 mb-3">Situações do Técnico</h3>
              <p className="text-sm text-slate-500 mb-3">
                Situações que o técnico pode registrar durante o atendimento.
              </p>
              <div className="space-y-2">
                {SITUACOES.map((sit, idx) => (
                  <div key={sit.value} className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
                    <span className="text-slate-600 w-6 text-center">{idx + 1}.</span>
                    <Input 
                      value={sit.label}
                      onChange={e => {
                        const newSituacoes = [...SITUACOES];
                        newSituacoes[idx] = { ...sit, label: e.target.value };
                        setSituacoes(newSituacoes);
                      }}
                      className="flex-1"
                    />
                    <Button 
                      variant="ghost" 
                      size="sm"
                      onClick={() => {
                        const newSituacoes = SITUACOES.filter((_, i) => i !== idx);
                        setSituacoes(newSituacoes);
                      }}
                      className="text-red-500 hover:text-red-600"
                    >
                      <X className="w-4 h-4" />
                    </Button>
                  </div>
                ))}
                <Button 
                  variant="outline" 
                  onClick={() => {
                    setSituacoes([...SITUACOES, { 
                      value: 'situacao_' + Date.now(), 
                      label: 'Nova Situação', 
                      icon: 'AlertTriangle' 
                    }]);
                  }}
                  className="w-full mt-2"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Adicionar Situação
                </Button>
              </div>
            </div>

            {/* Configurar Status */}
            <div>
              <h3 className="font-semibold text-slate-800 mb-3">Status da OS</h3>
              <p className="text-sm text-slate-500 mb-3">
                Status disponíveis para as ordens de serviço.
              </p>
              <div className="space-y-2">
                {STATUS_OS.map((st, idx) => (
                  <div key={st.value} className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
                    <span className={`w-3 h-3 rounded-full ${st.color.split(' ')[0]}`}></span>
                    <Input 
                      value={st.label}
                      onChange={e => {
                        const newStatus = [...STATUS_OS];
                        newStatus[idx] = { ...st, label: e.target.value };
                        setStatusOS(newStatus);
                      }}
                      className="flex-1"
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t">
              <Button variant="outline" onClick={() => setConfigModalOpen(false)}>Cancelar</Button>
              <Button 
                onClick={() => {
                  // Salvar configurações no backend
                  axios.post(API + '/ordens-servico/configuracoes', {
                    status_os: STATUS_OS,
                    situacoes: SITUACOES
                  }, { headers: getAuthHeader() })
                    .then(() => {
                      toast.success('Configurações salvas!');
                      setConfigModalOpen(false);
                    })
                    .catch(() => toast.error('Erro ao salvar configurações'));
                }}
                className="bg-blue-600 hover:bg-blue-700"
              >
                Salvar Configurações
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal de Finalização de OS */}
      <Dialog open={finalizarModalOpen} onOpenChange={setFinalizarModalOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-green-600" />
              Finalizar Ordem de Serviço
            </DialogTitle>
          </DialogHeader>
          
          {selectedOS && (
            <div className="space-y-4">
              {/* Info da OS */}
              <div className="bg-slate-50 p-3 rounded-lg">
                <p className="font-medium text-slate-800">OS #{selectedOS.numero || selectedOS.id?.slice(0,8)}</p>
                <p className="text-sm text-slate-600">{selectedOS.cliente_nome}</p>
                {selectedOS.titulo && <p className="text-sm text-slate-500 mt-1">{selectedOS.titulo}</p>}
              </div>

              {/* Serviço Realizado - Campo obrigatório */}
              <div className="space-y-2">
                <Label className="text-slate-700">
                  O que foi realizado? <span className="text-red-500">*</span>
                </Label>
                <textarea 
                  value={servicoRealizado}
                  onChange={e => setServicoRealizado(e.target.value)}
                  className="w-full h-24 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm resize-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  placeholder="Descreva o serviço executado... Ex: Instalação de fibra óptica concluída, roteador configurado, velocidade testada 500mbps."
                  required
                />
              </div>

              {/* Observações - Campo opcional */}
              <div className="space-y-2">
                <Label className="text-slate-700">Observações adicionais (opcional)</Label>
                <textarea 
                  value={observacaoFinal}
                  onChange={e => setObservacaoFinal(e.target.value)}
                  className="w-full h-20 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm resize-none focus:ring-2 focus:ring-slate-400"
                  placeholder="Informações extras, pendências, recomendações ao cliente..."
                />
              </div>

              {/* Botões */}
              <div className="flex justify-end gap-3 pt-4 border-t">
                <Button variant="outline" onClick={() => setFinalizarModalOpen(false)}>
                  Cancelar
                </Button>
                <Button 
                  onClick={handleFinalizarOS}
                  disabled={loadingAction || !servicoRealizado.trim()}
                  className="bg-green-600 hover:bg-green-700"
                >
                  {loadingAction && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
                  <CheckCircle className="w-4 h-4 mr-2" />
                  Finalizar OS
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de Detalhes da OS */}
      <Dialog open={detalhesModalOpen} onOpenChange={setDetalhesModalOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ClipboardList className="w-5 h-5 text-blue-600" />
              Detalhes da OS #{selectedOS?.numero || selectedOS?.id?.slice(0,8)}
            </DialogTitle>
          </DialogHeader>
          
          {selectedOS && (
            <div className="space-y-4">
              {/* Status Badge */}
              <div className="flex items-center justify-between">
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                  selectedOS.status === 'finalizada' ? 'bg-green-100 text-green-700' :
                  selectedOS.status === 'em_andamento' ? 'bg-blue-100 text-blue-700' :
                  selectedOS.status === 'cancelada' ? 'bg-red-100 text-red-700' :
                  'bg-yellow-100 text-yellow-700'
                }`}>
                  {selectedOS.status?.replace('_', ' ').toUpperCase() || 'ABERTA'}
                </span>
                <span className={`px-2 py-1 rounded text-xs font-medium ${
                  selectedOS.prioridade === 'urgente' ? 'bg-red-100 text-red-700' :
                  selectedOS.prioridade === 'alta' ? 'bg-orange-100 text-orange-700' :
                  selectedOS.prioridade === 'baixa' ? 'bg-slate-100 text-slate-600' :
                  'bg-blue-100 text-blue-700'
                }`}>
                  Prioridade: {selectedOS.prioridade?.toUpperCase() || 'NORMAL'}
                </span>
              </div>

              {/* Info do Cliente */}
              <div className="bg-slate-50 p-4 rounded-lg space-y-2">
                <h4 className="font-semibold text-slate-700 flex items-center gap-2">
                  <User className="w-4 h-4" /> Cliente
                </h4>
                <p className="text-slate-800 font-medium">{selectedOS.cliente_nome || 'Não informado'}</p>
                {selectedOS.cliente_telefone && (
                  <p className="text-sm text-slate-600 flex items-center gap-2">
                    <Phone className="w-3 h-3" /> {selectedOS.cliente_telefone}
                  </p>
                )}
                {selectedOS.cliente_endereco && (
                  <p className="text-sm text-slate-600 flex items-center gap-2">
                    <MapPin className="w-3 h-3" /> {selectedOS.cliente_endereco}
                  </p>
                )}
              </div>

              {/* Descrição */}
              <div className="space-y-2">
                <h4 className="font-semibold text-slate-700">Título</h4>
                <p className="text-slate-800">{selectedOS.titulo || 'Sem título'}</p>
              </div>

              {selectedOS.descricao && (
                <div className="space-y-2">
                  <h4 className="font-semibold text-slate-700">Descrição</h4>
                  <p className="text-slate-600 whitespace-pre-wrap bg-slate-50 p-3 rounded">{selectedOS.descricao}</p>
                </div>
              )}

              {/* Datas */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-slate-50 p-3 rounded">
                  <p className="text-xs text-slate-500">Data Abertura</p>
                  <p className="font-medium text-slate-700">
                    {selectedOS.data_abertura ? new Date(selectedOS.data_abertura).toLocaleString('pt-BR') : '-'}
                  </p>
                </div>
                <div className="bg-slate-50 p-3 rounded">
                  <p className="text-xs text-slate-500">Data Agendamento</p>
                  <p className="font-medium text-slate-700">
                    {selectedOS.data_agendamento ? new Date(selectedOS.data_agendamento).toLocaleString('pt-BR') : '-'}
                  </p>
                </div>
                {selectedOS.data_inicio && (
                  <div className="bg-slate-50 p-3 rounded">
                    <p className="text-xs text-slate-500">Data Início</p>
                    <p className="font-medium text-slate-700">
                      {new Date(selectedOS.data_inicio).toLocaleString('pt-BR')}
                    </p>
                  </div>
                )}
                {selectedOS.data_conclusao && (
                  <div className="bg-green-50 p-3 rounded">
                    <p className="text-xs text-green-600">Data Conclusão</p>
                    <p className="font-medium text-green-700">
                      {new Date(selectedOS.data_conclusao).toLocaleString('pt-BR')}
                    </p>
                  </div>
                )}
              </div>

              {/* Técnico */}
              {selectedOS.tecnico_nome && (
                <div className="space-y-2">
                  <h4 className="font-semibold text-slate-700 flex items-center gap-2">
                    <Wrench className="w-4 h-4" /> Técnico Responsável
                  </h4>
                  <p className="text-slate-800">{selectedOS.tecnico_nome}</p>
                </div>
              )}

              {/* Serviço Realizado */}
              {selectedOS.servico_realizado && (
                <div className="space-y-2 bg-green-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-green-700 flex items-center gap-2">
                    <CheckCircle className="w-4 h-4" /> Serviço Realizado
                  </h4>
                  <p className="text-green-800 whitespace-pre-wrap">{selectedOS.servico_realizado}</p>
                </div>
              )}

              {/* Observações */}
              {selectedOS.observacoes && (
                <div className="space-y-2">
                  <h4 className="font-semibold text-slate-700">Observações / Histórico</h4>
                  <div className="bg-slate-50 p-3 rounded max-h-48 overflow-y-auto">
                    <p className="text-sm text-slate-600 whitespace-pre-wrap">{selectedOS.observacoes}</p>
                  </div>
                </div>
              )}

              {/* Situação */}
              {selectedOS.situacao && (
                <div className="space-y-2">
                  <h4 className="font-semibold text-slate-700">Última Situação</h4>
                  <span className="px-3 py-1 bg-slate-100 text-slate-700 rounded-full text-sm">
                    {selectedOS.situacao.replace(/_/g, ' ')}
                  </span>
                </div>
              )}

              {/* Info IXC */}
              {selectedOS.ixc_os_id && (
                <div className="border-t pt-4 mt-4">
                  <p className="text-xs text-slate-400">
                    Sincronizado com IXC - ID: {selectedOS.ixc_os_id}
                  </p>
                </div>
              )}

              {/* Botões */}
              <div className="flex justify-end gap-3 pt-4 border-t">
                <Button variant="outline" onClick={() => setDetalhesModalOpen(false)}>
                  Fechar
                </Button>
                {selectedOS.status !== 'finalizada' && selectedOS.status !== 'cancelada' && (
                  <Button 
                    onClick={() => { setDetalhesModalOpen(false); openFinalizarModal(selectedOS); }}
                    className="bg-green-600 hover:bg-green-700"
                  >
                    <CheckCircle className="w-4 h-4 mr-2" />
                    Finalizar OS
                  </Button>
                )}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de Execução Técnica */}
      <Dialog open={execucaoModalOpen} onOpenChange={setExecucaoModalOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Wrench className="w-5 h-5 text-purple-600" />
              Execução Técnica - OS #{selectedOS?.numero || selectedOS?.id?.slice(0,8)}
            </DialogTitle>
          </DialogHeader>
          
          {selectedOS && (
            <div className="space-y-6">
              {/* Info do Cliente */}
              <div className="bg-slate-50 p-4 rounded-lg">
                <h4 className="font-semibold text-slate-700 mb-2">{selectedOS.cliente_nome}</h4>
                <p className="text-sm text-slate-600 flex items-center gap-2">
                  <MapPin className="w-3 h-3" /> {selectedOS.cliente_endereco || 'Sem endereço'}
                </p>
                {selectedOS.cliente_telefone && (
                  <p className="text-sm text-slate-600 flex items-center gap-2 mt-1">
                    <Phone className="w-3 h-3" /> {selectedOS.cliente_telefone}
                  </p>
                )}
              </div>

              {/* Status de Atendimento */}
              <div className="space-y-3">
                <Label className="text-sm font-semibold">Status de Atendimento</Label>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                  {STATUS_ATENDIMENTO_TECNICO.map(status => {
                    const StatusIcon = ICON_MAP[status.iconName] || Clock;
                    const isSelected = execucaoData.status_atendimento === status.value;
                    const isDisabled = (status.value === 'finalizado_tecnico' || status.value === 'nao_realizado') && !execucaoData.servico_realizado;
                    return (
                      <Button
                        key={status.value}
                        type="button"
                        variant={isSelected ? "default" : "outline"}
                        className={`justify-start h-auto py-3 ${isSelected ? 'bg-purple-600 hover:bg-purple-700' : ''}`}
                        onClick={() => setExecucaoData({...execucaoData, status_atendimento: status.value})}
                        disabled={isDisabled}
                        data-testid={`status-${status.value}`}
                      >
                        <StatusIcon className="w-4 h-4 mr-2" />
                        <span className="text-xs">{status.label}</span>
                      </Button>
                    );
                  })}
                </div>
              </div>

              {/* Serviço Realizado? */}
              <div className="space-y-3">
                <Label className="text-sm font-semibold">Serviço foi realizado?</Label>
                <div className="flex gap-2">
                  {SERVICO_REALIZADO_OPTIONS.map(opt => (
                    <Button
                      key={opt.value}
                      type="button"
                      variant={execucaoData.servico_realizado === opt.value ? "default" : "outline"}
                      className={execucaoData.servico_realizado === opt.value ? opt.color.replace('text-', 'bg-').split(' ')[0] : ''}
                      onClick={() => setExecucaoData({
                        ...execucaoData, 
                        servico_realizado: opt.value,
                        motivo_nao_execucao: opt.value !== 'nao' ? '' : execucaoData.motivo_nao_execucao
                      })}
                      data-testid={`servico-${opt.value}`}
                    >
                      {opt.label}
                    </Button>
                  ))}
                </div>
              </div>

              {/* Descrição do Serviço (obrigatório se sim/parcial) */}
              {(execucaoData.servico_realizado === 'sim' || execucaoData.servico_realizado === 'parcial') && (
                <div className="space-y-2">
                  <Label className="text-sm font-semibold">
                    Descrição detalhada do serviço realizado <span className="text-red-500">*</span>
                  </Label>
                  <textarea
                    className="w-full p-3 border rounded-md min-h-[100px] focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    placeholder="Descreva detalhadamente o que foi feito..."
                    value={execucaoData.descricao_servico}
                    onChange={e => setExecucaoData({...execucaoData, descricao_servico: e.target.value})}
                    data-testid="descricao-servico"
                  />
                </div>
              )}

              {/* Motivo de não execução (obrigatório se não) */}
              {execucaoData.servico_realizado === 'nao' && (
                <div className="space-y-3">
                  <Label className="text-sm font-semibold">
                    Motivo da não execução <span className="text-red-500">*</span>
                  </Label>
                  <div className="grid grid-cols-2 gap-2">
                    {MOTIVOS_NAO_EXECUCAO.map(motivo => (
                      <Button
                        key={motivo.value}
                        type="button"
                        variant={execucaoData.motivo_nao_execucao === motivo.value ? "default" : "outline"}
                        className={`justify-start ${execucaoData.motivo_nao_execucao === motivo.value ? 'bg-red-600 hover:bg-red-700' : ''}`}
                        onClick={() => setExecucaoData({...execucaoData, motivo_nao_execucao: motivo.value})}
                        data-testid={`motivo-${motivo.value}`}
                      >
                        {motivo.label}
                      </Button>
                    ))}
                  </div>
                  
                  {execucaoData.motivo_nao_execucao === 'outro' && (
                    <textarea
                      className="w-full p-3 border rounded-md min-h-[80px] focus:ring-2 focus:ring-red-500"
                      placeholder="Especifique o motivo..."
                      value={execucaoData.motivo_outro}
                      onChange={e => setExecucaoData({...execucaoData, motivo_outro: e.target.value})}
                      data-testid="motivo-outro-texto"
                    />
                  )}
                </div>
              )}

              {/* Upload de Fotos */}
              <div className="space-y-3 border-t pt-4">
                <Label className="text-sm font-semibold flex items-center gap-2">
                  <Camera className="w-4 h-4" /> Fotos do Serviço
                </Label>
                
                <div className="flex gap-2 items-center">
                  <select
                    className="p-2 border rounded-md text-sm"
                    value={fotoCategoria}
                    onChange={e => setFotoCategoria(e.target.value)}
                  >
                    {CATEGORIAS_FOTOS.map(cat => (
                      <option key={cat.value} value={cat.value}>{cat.label}</option>
                    ))}
                  </select>
                  
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    className="hidden"
                    onChange={handleUploadFoto}
                  />
                  
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => fileInputRef.current?.click()}
                    disabled={uploadingFoto}
                    data-testid="upload-foto-btn"
                  >
                    {uploadingFoto ? (
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    ) : (
                      <Upload className="w-4 h-4 mr-2" />
                    )}
                    {uploadingFoto ? 'Enviando...' : 'Adicionar Foto'}
                  </Button>
                </div>

                {/* Galeria de fotos */}
                {selectedOS.execucao_tecnica?.fotos?.length > 0 && (
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-3">
                    {selectedOS.execucao_tecnica.fotos.map(foto => (
                      <div key={foto.id} className="relative group">
                        <img 
                          src={API.replace('/api', '') + foto.url} 
                          alt={foto.categoria}
                          className="w-full h-24 object-cover rounded-md border"
                        />
                        <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-md flex items-center justify-center">
                          <Button
                            type="button"
                            size="sm"
                            variant="destructive"
                            onClick={() => handleRemoverFoto(foto.id)}
                            className="h-8 w-8 p-0"
                          >
                            <X className="w-4 h-4" />
                          </Button>
                        </div>
                        <span className="absolute bottom-1 left-1 text-[10px] bg-black/60 text-white px-1 rounded">
                          {CATEGORIAS_FOTOS.find(c => c.value === foto.categoria)?.label || foto.categoria}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Timestamps */}
              {selectedOS.execucao_tecnica && (
                <div className="bg-slate-50 p-3 rounded-lg text-xs text-slate-600 space-y-1">
                  {selectedOS.execucao_tecnica.data_hora_inicio_atendimento && (
                    <p>Início: {new Date(selectedOS.execucao_tecnica.data_hora_inicio_atendimento).toLocaleString('pt-BR')}</p>
                  )}
                  {selectedOS.execucao_tecnica.data_hora_fim_atendimento && (
                    <p>Fim: {new Date(selectedOS.execucao_tecnica.data_hora_fim_atendimento).toLocaleString('pt-BR')}</p>
                  )}
                  {selectedOS.execucao_tecnica.tempo_total_atendimento && (
                    <p className="font-medium">Tempo total: {selectedOS.execucao_tecnica.tempo_total_atendimento} minutos</p>
                  )}
                </div>
              )}

              {/* Botões de Ação */}
              <div className="flex flex-wrap justify-end gap-2 pt-4 border-t">
                <Button variant="outline" onClick={() => setExecucaoModalOpen(false)}>
                  Cancelar
                </Button>
                
                {execucaoData.status_atendimento && execucaoData.status_atendimento !== 'finalizado_tecnico' && execucaoData.status_atendimento !== 'nao_realizado' && (
                  <Button 
                    onClick={() => handleAtualizarExecucao(execucaoData.status_atendimento)}
                    disabled={loadingAction}
                    className="bg-purple-600 hover:bg-purple-700"
                    data-testid="salvar-status-btn"
                  >
                    {loadingAction && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
                    Salvar Status
                  </Button>
                )}
                
                {execucaoData.servico_realizado && (
                  <Button 
                    onClick={() => handleAtualizarExecucao(execucaoData.servico_realizado === 'nao' ? 'nao_realizado' : 'finalizado_tecnico')}
                    disabled={loadingAction}
                    className={execucaoData.servico_realizado === 'nao' ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'}
                    data-testid="finalizar-tecnico-btn"
                  >
                    {loadingAction && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
                    {execucaoData.servico_realizado === 'nao' ? 'Registrar Não Realizado' : 'Finalizar Atendimento'}
                  </Button>
                )}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de Validação (Atendente) */}
      <Dialog open={validarModalOpen} onOpenChange={setValidarModalOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileCheck className="w-5 h-5 text-teal-600" />
              Validar Finalização - OS #{selectedOS?.numero}
            </DialogTitle>
          </DialogHeader>
          
          {selectedOS && (
            <div className="space-y-4">
              <div className="bg-slate-50 p-4 rounded-lg">
                <p className="font-medium">{selectedOS.cliente_nome}</p>
                <p className="text-sm text-slate-600 mt-1">
                  Status: <span className={`px-2 py-0.5 rounded-full text-xs ${getStatusBadge(selectedOS.status).color}`}>
                    {getStatusBadge(selectedOS.status).label}
                  </span>
                </p>
                
                {selectedOS.execucao_tecnica && (
                  <div className="mt-3 pt-3 border-t text-sm">
                    <p><strong>Serviço:</strong> {SERVICO_REALIZADO_OPTIONS.find(s => s.value === selectedOS.execucao_tecnica.servico_realizado)?.label || '-'}</p>
                    {selectedOS.execucao_tecnica.descricao_servico && (
                      <p className="mt-1"><strong>Descrição:</strong> {selectedOS.execucao_tecnica.descricao_servico}</p>
                    )}
                    {selectedOS.execucao_tecnica.motivo_nao_execucao && (
                      <p className="mt-1 text-red-600">
                        <strong>Motivo:</strong> {MOTIVOS_NAO_EXECUCAO.find(m => m.value === selectedOS.execucao_tecnica.motivo_nao_execucao)?.label}
                        {selectedOS.execucao_tecnica.motivo_outro && ` - ${selectedOS.execucao_tecnica.motivo_outro}`}
                      </p>
                    )}
                    {selectedOS.execucao_tecnica.tempo_total_atendimento && (
                      <p className="mt-1"><strong>Tempo:</strong> {selectedOS.execucao_tecnica.tempo_total_atendimento} minutos</p>
                    )}
                  </div>
                )}
              </div>

              {/* Fotos anexadas */}
              {selectedOS.execucao_tecnica?.fotos?.length > 0 && (
                <div>
                  <Label className="text-sm font-semibold mb-2 block">Fotos Anexadas</Label>
                  <div className="grid grid-cols-4 gap-2">
                    {selectedOS.execucao_tecnica.fotos.map(foto => (
                      <img 
                        key={foto.id}
                        src={API.replace('/api', '') + foto.url} 
                        alt={foto.categoria}
                        className="w-full h-16 object-cover rounded border cursor-pointer hover:opacity-80"
                        onClick={() => window.open(API.replace('/api', '') + foto.url, '_blank')}
                      />
                    ))}
                  </div>
                </div>
              )}

              <div className="flex gap-2 pt-4 border-t">
                <Button 
                  variant="outline" 
                  className="flex-1"
                  onClick={() => handleValidarOS('rejeitar', 'Serviço requer revisão')}
                  disabled={loadingAction}
                  data-testid="rejeitar-validacao-btn"
                >
                  <XCircle className="w-4 h-4 mr-2" />
                  Devolver ao Técnico
                </Button>
                <Button 
                  className="flex-1 bg-green-600 hover:bg-green-700"
                  onClick={() => handleValidarOS('aprovar')}
                  disabled={loadingAction}
                  data-testid="aprovar-validacao-btn"
                >
                  {loadingAction ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle className="w-4 h-4 mr-2" />}
                  Aprovar e Finalizar
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de Mensagem ao Cliente */}
      <Dialog open={mensagemModalOpen} onOpenChange={setMensagemModalOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <MessageSquare className="w-5 h-5 text-green-600" />
              Enviar Mensagem ao Cliente
            </DialogTitle>
          </DialogHeader>
          
          {selectedOS && (
            <div className="space-y-4">
              <p className="text-sm text-slate-600">
                Enviar mensagem para: <strong>{selectedOS.cliente_nome}</strong>
              </p>
              <p className="text-sm text-slate-500">
                Telefone: {selectedOS.cliente_telefone}
              </p>

              <div className="space-y-2">
                <Button
                  className="w-full justify-start bg-green-600 hover:bg-green-700"
                  onClick={() => handleEnviarMensagemCliente('tecnico_a_caminho')}
                  disabled={loadingAction}
                  data-testid="msg-tecnico-caminho"
                >
                  <Car className="w-4 h-4 mr-2" />
                  Técnico a caminho, prepare-se!
                </Button>
                
                <Button
                  className="w-full justify-start"
                  variant="outline"
                  onClick={() => handleEnviarMensagemCliente('chegada_prevista')}
                  disabled={loadingAction}
                  data-testid="msg-chegada-prevista"
                >
                  <Clock className="w-4 h-4 mr-2" />
                  Chegada em aproximadamente 30 min
                </Button>
                
                <Button
                  className="w-full justify-start"
                  variant="outline"
                  onClick={() => handleEnviarMensagemCliente('atraso')}
                  disabled={loadingAction}
                  data-testid="msg-atraso"
                >
                  <AlertTriangle className="w-4 h-4 mr-2" />
                  Informar pequeno atraso
                </Button>
              </div>

              <div className="pt-4 border-t">
                <Button variant="outline" className="w-full" onClick={() => setMensagemModalOpen(false)}>
                  Cancelar
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
